import type { UIEvent } from 'react';

import { useCallback, useState } from 'react';

import { app, checkout } from 'core';
import { Bff } from 'core/services';

const eventAction = 'clique:botao';
const eventCategory = 'carrinho:revisao';
const eventLabel = 'os-dados-do-cartao-serao-apagados';
const interactionModal = 'interacao:modal';

export const useCheckout = () => {
  const [contentType, setContentType] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { trackClick } = app.commands.useAppCommand();
  const { paymentPlanType } = checkout.hooks.usePaymentOption();
  const { setStep, setCreditCardOption } = checkout.commands.useCheckoutCommand();

  const isCreditCard = paymentPlanType === Bff.PAYMENT_PLAN_TYPE.CREDIT_CARD;

  const handleOnClose = useCallback((event: UIEvent<HTMLButtonElement>) => {
    const label = event.currentTarget.innerText || 'fechar';
    setContentType('');
    setIsModalOpen((prev) => !prev);

    trackClick(event, 'event', {
      eventAction,
      eventCategory: interactionModal,
      eventLabel: `${eventLabel}:${label}`,
    });

    trackClick(event, 'event', {
      eventAction: interactionModal,
      eventCategory,
      eventLabel: `fechar:${eventLabel}`,
    });
  }, []);

  const handleSetStep = (event: UIEvent<HTMLButtonElement>) => {
    const label = event.currentTarget.innerText;

    trackClick(event, 'event', {
      eventAction,
      eventCategory: interactionModal,
      eventLabel: `${eventLabel}:${label}`,
    });

    setStep('payment');

    if (isCreditCard) {
      setCreditCardOption({ paymentMode: Bff.PAYMENT_PLAN_TYPE.CREDIT_CARD });
    }
  };

  return {
    contentType,
    handleOnClose,
    handleSetStep,
    isCreditCard,
    isModalOpen,
    setContentType,
    setIsModalOpen,
  };
};
